import axios from "axios";
import {ClientConfig} from "../api/Model";

const defaultConfig: ClientConfig = {
    googleClientID: '893849882782-0caiepnteplu9spn597ekt7j4jalpcuc.apps.googleusercontent.com',
    webSocketUrl: 'ws://localhost:8080',
    forceRefreshVersion: 1,
}

async function getConfig(): Promise<ClientConfig> {
    try {
        const response = await axios.get('/api/config');
        if (response.status === 200) {
            return response.data;
        } else {
            console.error('Failed to load client config', response.statusText, response.data);
            return defaultConfig;
        }
    } catch (e) {
        console.error('Failed to load client config', e);
        return defaultConfig;
    }
}

const config = getConfig();
export default config;